import BaseClient from '@/app/model/api/response/baseApiClient'

class RecordDeleteApi extends BaseClient {
  public doRecordDelete (plantingId: string, recordDate: string) {
    const path: string = '/v1/planting-records/' + plantingId + '/' + recordDate

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new RecordDeleteApi()
